module.exports = __webpack_public_path__ + "static/media/rejectIcon.cfeebeb6.gif";